const cardItems = [
  {
    id: 1,
    title: '进击的巨人 最终季',
    category: '暗黑奇幻 · 已完结',
    description: '艾伦与巨人之力的最终对决，人类命运何去何从。全集高清画质已上线，51漫画免费版下载一次性获取全部139话。',
    image: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20style%20epic%20manga%20illustration%20with%20towering%20walls%20and%20colossal%20figures%2C%20dark%20dramatic%20tones%20with%20warm%20amber%20sky%2C%20cinematic%20wide%20composition%2C%20apocalyptic%20atmosphere%2C%20intense%20emotional%20lighting&width=600&height=420&seq=card-1&orientation=landscape',
  },
  {
    id: 2,
    title: '排球少年!! 垃圾场对决',
    category: '体育竞技 · 已完结',
    description: '乌野高校排球部的热血青春，日向与影山的传奇搭档。51漫画下载全集离线看，重温每一场激动人心的比赛。',
    image: 'https://readdy.ai/api/search-image?query=Haikyuu%20style%20volleyball%20manga%20illustration%20with%20dynamic%20jumping%20poses%20in%20gymnasium%2C%20bright%20energetic%20orange%20and%20cream%20tones%2C%20sports%20action%20composition%2C%20inspiring%20teamwork%20atmosphere%2C%20dramatic%20sports%20lighting&width=600&height=420&seq=card-2&orientation=landscape',
  },
  {
    id: 3,
    title: '一人之下 碧游村篇',
    category: '国漫玄幻 · 连载中',
    description: '张楚岚与冯宝宝的异人世界冒险，国漫巅峰之作。51漫画免费版下载同步追更，国产漫画爱好者必读神作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20style%20illustration%20with%20mystical%20energy%20flows%20and%20urban%20fantasy%20elements%2C%20vermilion%20and%20ink%20black%20tones%2C%20dynamic%20combat%20composition%2C%20modern%20Chinese%20comic%20aesthetic%2C%20dramatic%20atmospheric%20lighting&width=600&height=420&seq=card-3&orientation=landscape',
  },
  {
    id: 4,
    title: '我独自升级 最终章',
    category: '韩漫动作 · 已完结',
    description: '成振宇从最弱猎人成长为最强君主，韩漫现象级作品。支持51漫画下载全集高清资源，见证史诗级打怪升级之路。',
    image: 'https://readdy.ai/api/search-image?query=Solo%20Leveling%20style%20dark%20fantasy%20manhwa%20illustration%20with%20shadow%20army%20and%20neon%20purple%20energy%2C%20sleek%20Korean%20webtoon%20art%2C%20epic%20power%20fantasy%20composition%2C%20dramatic%20cool%20toned%20lighting%2C%20cinematic%20scale&width=600&height=420&seq=card-4&orientation=landscape',
  },
  {
    id: 5,
    title: '迷宫饭 美食冒险',
    category: '奇幻美食 · 已完结',
    description: '在迷宫中烹饪魔物美食的独特冒险，创意满分。51漫画免费版下载全集，轻松幽默中品味奇幻世界的美食哲学。',
    image: 'https://readdy.ai/api/search-image?query=Dungeon%20Meshi%20style%20fantasy%20cooking%20manga%20illustration%20with%20monster%20food%20in%20dungeon%20setting%2C%20warm%20earthy%20brown%20and%20cream%20tones%2C%20cozy%20adventure%20composition%2C%20wholesome%20atmospheric%20lighting%2C%20detailed%20culinary%20art&width=600&height=420&seq=card-5&orientation=landscape',
  },
  {
    id: 6,
    title: '蓝色监狱 新英雄大战',
    category: '体育竞技 · 连载中',
    description: '300名高中前锋的生存竞争，足球漫画的革命之作。51漫画下载最新话，体验独特的利己主义足球哲学与激烈对决。',
    image: 'https://readdy.ai/api/search-image?query=Blue%20Lock%20style%20intense%20soccer%20manga%20illustration%20with%20dynamic%20striker%20poses%20on%20field%2C%20cool%20blue%20and%20white%20tones%2C%20competitive%20sports%20composition%2C%20fierce%20determined%20atmosphere%2C%20stadium%20lighting&width=600&height=420&seq=card-6&orientation=landscape',
  },
  {
    id: 7,
    title: '药屋少女的呢喃',
    category: '宫廷悬疑 · 连载中',
    description: '猫猫在后宫中的药理推理，独特中华风宫廷剧。51漫画免费版下载全集离线看，细腻画风与精妙推理并存的人气作品。',
    image: 'https://readdy.ai/api/search-image?query=Apothecary%20Diaries%20style%20historical%20mystery%20manga%20illustration%20with%20Chinese%20palace%20setting%20and%20elegant%20herb%20motifs%2C%20warm%20jade%20green%20and%20vermilion%20tones%2C%20graceful%20composition%2C%20refined%20atmospheric%20lighting%2C%20traditional%20court%20aesthetic&width=600&height=420&seq=card-7&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            漫画精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            编辑精选51漫画下载热门作品，品质内容不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.slice(0, 6).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 51漫画下载`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-secondary-500/85 text-background-50 rounded-full whitespace-nowrap">
                    {item.category.split('·')[0].trim()}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-500 mb-1">{item.category}</p>
                <h3 className="font-heading text-base text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
          <a
            href="#index"
            className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer sm:col-span-2 lg:col-span-3"
          >
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/3 aspect-[4/3] md:aspect-auto overflow-hidden">
                <img
                  src={cardItems[6].image}
                  alt={`${cardItems[6].title} - 51漫画下载`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 md:p-7 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 w-fit whitespace-nowrap">
                  编辑力荐
                </span>
                <h3 className="font-heading text-xl text-foreground-900 mb-2">
                  {cardItems[6].title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3">{cardItems[6].category}</p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cardItems[6].description}
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}